import Footer from "../../components/common/Footer";
import RegisterNavbar from "../../components/registration/RegisterNavbar";
import RegisterNeedInfo from "../../components/registration/RegisterNeedInfo";

export default function RegisterNeedInfoPage() {
  return (
    <>
      <RegisterNavbar />
      <RegisterNeedInfo />
      <Footer />
    </>
  );
}
